import React from 'react'
import styles from '../Ecllpsys/Ecllpsys.module.css'

const Ecllpsys = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.leftSection}>
                    <img src='Images/LeftImage2.webp' alt='diagram of contact lens showing Eclipsys™ hyper-refractive central zone and aspherical spherical surface' loading="lazy" decoding="async" />
                </div>
                <div className={styles.RightSection}>
                    <img src='Images/RightImage.webp' alt=' active couple planting flowers together' loading="lazy" decoding="async" />
                </div>
            </div>
        </div>
    )
}

export default Ecllpsys
